import { CustomField } from 'shared/models/visitor-info/custom-field';
import { PersonType } from '../../../common/common/constants/person-type.enum';

export interface VisitorInfoField {
  value: string | CustomField[] | number | PersonType;
  visible: boolean;
  translateKey?: string;
  type?: VisitorInfoFieldType;
  workItemId?: string;
  editable?: boolean;
}

export enum VisitorInfoFieldType {
  COMMON = 'common',
  DATE = 'date',
  LINKABLE = 'linkable',
  CUSTOM_FIELDS = 'customFields',
  EMAIL = 'email',
  PHONE = 'phone',
  PERSON_TYPE = 'personType',
  ENDED_REASON = 'endedReason',
  CLIENT_TYPE = 'clientType'
}
